import config from 'config';
import { CompletedSignupMachineContext } from 'domains/signup/signupFlow/signupMachine';

export const getJotformRedirectFromSignup = (context: CompletedSignupMachineContext) => {
  const queryParams = new URLSearchParams({
    cueid: context.leadID,
    cname: context.contactInfo.lastName,
    me: context.target === 'adult' ? 'yes' : 'no',
    phone: context.contactInfo.phoneNumber,
    email: context.contactInfo.email,
  }).toString();

  return `${config.get('salesforceInsuranceURL')}?${queryParams.toString()}`;
};
